import { BRAND_STYLE_TYPES } from "../constants";

export function getBrandId(brand) {
    return brand?.id;
}

export function getBrandName(brand) {
    return brand?.name;
}

export function getBrandDisplayName(brand) {
    return brand?.displayName || getBrandName(brand);
}

export function getBrandWithId(brandId, { brands }) {
    return brands?.find((b) => getBrandId(b) === brandId);
}

export function getBrandShopType(brand) {
    return brand?.shopType;
}

export function getBrandLogo(brand) {
    return brand?.logoSrc;
}

export function getBrandCurrency(brand) {
    return brand?.currency;
}

export function isBrandRiskSystemEnabled(brand) {
    return !!brand?.settings?.riskSystemEnabled;
}

export function brandButtonTypeToPx(brand) {
    return {
        [BRAND_STYLE_TYPES.SHARP]: "0px",
        [BRAND_STYLE_TYPES.SLIGHTLY_ROUNDED]: "3px",
        [BRAND_STYLE_TYPES.ROUNDED]: "6px",
        [BRAND_STYLE_TYPES.VERY_ROUNDED]: "10px",
        [BRAND_STYLE_TYPES.FULLY_ROUNDED]: "50px",
    }[brand?.settings?.buttonType];
}
